module.exports = __webpack_public_path__ + "img/p19.a32c0ab9.svg";